import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { retrieveTerms, cancelAllRequests, createTerm, deleteTerm, editTerm, clearPanelTreeList } from '../../actions/thesaurus';
import { attachUMOs } from '../../actions/umo';
import { retrieveThesaurusTermSearch } from '../../actions/umoGallery';
import { selectWorkspace } from '../../actions/workspacePreview';
import { toggleWorkspacePreview } from '../../actions/mainUI';
import { addError } from '../../actions/messageDialog';
import PanelTree from '../PanelTree';
import { stringifiedToDraggable } from '../../utils/draggables';
import { validateSessionConnection } from '../../actions/session';
import appConfig from '../../appConfig';
import CategoryDialog from '../CategoryDialog';
import AddSubCategoryIcon from '../Icons/AddSubCategoryDefault';
import EditIcon from '../Icons/EditDefaul';
import WorkspaceSmallIcon from '../Icons/WorkspaceSmallDefault';

const mapStateToProps = state => ({
  thesaurus: state.thesaurus,
  umoGallery: state.umoGallery,
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  dispatch: actionToDispatch => dispatch(actionToDispatch),
  retrieveTerms: () => dispatch(retrieveTerms()),
  retrieveChildTerm: termID => dispatch(retrieveTerms(termID)),
  clearPanelTreeList: categoryID => dispatch(clearPanelTreeList(categoryID)),
  onTermClick: (termID, termName) =>
    dispatch(retrieveThesaurusTermSearch(termID, termName, appConfig.thesaurus.id)),
  onEditSubmit: (termID, termName) => dispatch(editTerm(termID, termName)),
  onCreateSubmit: (parentID, name) => dispatch(createTerm(name, parentID)),
  onDeleteSubmit: termID => dispatch(deleteTerm(termID)),
  onAttachUMOs: (termID, umoList, searchParams) =>
    dispatch(attachUMOs(termID, umoList, searchParams)),
  cancelAllRequests: () => dispatch(cancelAllRequests()),
  selectWorkspace: (
    { workspaceID, workspaceName, workspaceDescription }
  ) => {
    dispatch(toggleWorkspacePreview(true));
    dispatch(
      selectWorkspace(workspaceID, workspaceName, workspaceDescription)
    );
  },
  showErrorMessage: (message) => {
    dispatch(addError(message));
  },
  validateSession: surl => dispatch(validateSessionConnection(surl)),
});

class NavThesaurusPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isCategoryDialogShown: false,
      isEdit: false,
      selectedCategoryData: null,
    };

    this.onCreateClick = this.onCreateClick.bind(this);
    this.onEditSelect = this.onEditSelect.bind(this);
    this.onPanelItemDrop = this.onPanelItemDrop.bind(this);
    this.onCategoryDialogToggle = this.onCategoryDialogToggle.bind(this);
  }

  componentDidMount() {
    // this.props.retrieveTerms();
    if (this.props.thesaurus.get('termsList').size === 0) this.props.retrieveTerms();
  }

  componentWillUnmount() {
    this.props.cancelAllRequests();
  }

  onCategoryDialogToggle(toggle) {
    this.setState({
      isCategoryDialogShown: toggle,
    });
  }

  onEditSelect(key, workspaceID, workspaceName) {
    this.props.validateSession(this.props.session.get('surl')).then((res) => {
      if (res.isValid) {
        switch (key) {
          case 'add':
            this.setState({
              isCategoryDialogShown: true,
              isEdit: false,
              selectedCategoryData: workspaceID ? {
                id: workspaceID,
                name: workspaceName,
              } : null,
            });
            break;
          case 'edit':
            this.setState({
              isCategoryDialogShown: true,
              isEdit: true,
              selectedCategoryData: {
                id: workspaceID,
                name: workspaceName,
              },
            });
            break;
          default:
            break;
        }
      }
      return null;
    });
  }

  onCreateClick() {
    this.props.validateSession(this.props.session.get('surl')).then((res) => {
      if (res.isValid) {
        this.setState({
          isCategoryDialogShown: true,
          isEdit: false,
          selectedCategoryData: null,
        });
      }
    });
    return null;
  }

  onPanelItemDrop(e, workspaceID) {
    e.preventDefault();
    $('.main__search-bar').removeAttr('style');
    const draggable = stringifiedToDraggable(e.dataTransfer.getData('text'));
    this.props.onAttachUMOs(workspaceID, draggable.getSelectionList(),
      draggable.getIsSelectAll() ? draggable.getSearchParams() : null);
  }

  render() {
    return (
      <div className="nav-content__body nav-highlights">
        <h2 className="nav-content__title nav-content__title--with-sub">
          {appConfig.thesaurus.mainLabel ? appConfig.thesaurus.mainLabel :
            this.props.intl.formatMessage({ id: 'navThesaurusPanel.thesaurusHeader' })}
        </h2>
        <PanelTree
          onPanelItemClick={this.props.onTermClick}
          onPanelItemDrop={this.onPanelItemDrop}
          retrievePanelTreeList={this.props.retrieveChildTerm}
          clearPanelTreeList={this.props.clearPanelTreeList}
          panelTreeList={this.props.thesaurus.get('termsList')}
          retrieveChildrenRequests={this.props.thesaurus.get('retrieveChildrenRequests')}
          onEditSelect={this.onEditSelect}
          editOptions={[
            { eventKey: 'add', icon: <AddSubCategoryIcon />, label: this.props.intl.formatMessage({ id: 'thesaurusDialog.addHeader' }) },
            { eventKey: 'edit', icon: <EditIcon />, label: this.props.intl.formatMessage({ id: 'thesaurusDialog.editHeader' }) },
          ]}
          editRequests={this.props.thesaurus.get('editRequests')}
          isRoot
          isRetrievingRoot={this.props.thesaurus.get('isRetrievingRoot')}
          icon={<WorkspaceSmallIcon style={{margin: '0 6px'}}/>}
        />

        {this.state.dialogToShow}
        <CategoryDialog
          isCategoryDialogShown={this.state.isCategoryDialogShown}
          onCategoryDialogToggle={this.onCategoryDialogToggle}
          selectedCategoryData={this.state.selectedCategoryData}
          isEdit={this.state.isEdit}
          editRequests={this.props.thesaurus.get('editRequests')}
          createRequests={this.props.thesaurus.get('createRequests')}
          onEditSubmit={this.props.onEditSubmit}
          onCreateSubmit={this.props.onCreateSubmit}
          onDeleteSubmit={this.props.onDeleteSubmit}
          isThesaurus
        />
      </div>
    );
  }
}

NavThesaurusPanel.propTypes = {
  thesaurus: PropTypes.instanceOf(Map),
  session: PropTypes.instanceOf(Map),
  retrieveTerms: PropTypes.func,
  clearPanelTreeList: PropTypes.func,
  cancelAllRequests: PropTypes.func,
  onTermClick: PropTypes.func,
  onEditSubmit: PropTypes.func,
  onDeleteSubmit: PropTypes.func,
  onCreateSubmit: PropTypes.func,
  retrieveChildTerm: PropTypes.func,
  onAttachUMOs: PropTypes.func,
  validateSession: PropTypes.func,
  dispatch: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(NavThesaurusPanel));
